import { makeAutoObservable, computed } from "mobx";
import { SaveStoreApi } from "../API/SaveStore";
import {
  EmptyModulePropImpl,
  EmptyModuleWithResourcesAndTasksImpl,
  ModuleWithResourcesAndTasksResponseApi,
  ObservableModulePropImpl,
} from "../../DTO/ServerResponseType/Module/Module";
import { ModuleResourcesStore } from "./ModuleResourcesStore";
import { CheckArgs } from "../../utils/checks/CheckArgsWithoutThrow";
import ModuleServerClient from "../../ServerClients/ModuleServerClient";
import {
  ModuleResourceRequestImpl,
  ModuleWithResourcesAndTasksRequestImpl,
} from "../../DTO/ClientRequest/ModuleRequest";
import { ModuleIdsApi } from "../../DTO/ServerResponseType/Module/ModuleId";
import { ModuleResourceWithScenarioOrMaterialResponseApi } from "../../DTO/ServerResponseType/Module/ModuleResource";
import { ModuleResourceRowDTO } from "../../ProfileWindow/AdminWindows/ModuleEditWindow/DTO/ModuleResourceRowDTO";

export class ModuleStore implements SaveStoreApi {
  module: ObservableModulePropImpl;
  moduleResourcesStore: ModuleResourcesStore;

  constructor() {
    this.moduleResourcesStore = new ModuleResourcesStore(this);
    this.module = new ObservableModulePropImpl(new EmptyModulePropImpl());
    makeAutoObservable(this);
  }
  withNavigationAfterSaving: boolean = true;

  onChangeName = (event: React.FormEvent<HTMLInputElement>) => {
    this.module.onChangeName(event.currentTarget.value);
  };

  @computed get saveWindowTitle(): string {
    return this.module.moduleId === ""
      ? "Создание модуля"
      : "Обновление модуля";
  }

  @computed get saveButtonText(): string {
    return this.module.moduleId === "" ? "Создать модуль" : "Обновить модуль";
  }

  @computed get saveClickAsync() {
    let savePromise;

    let moduleResources = this.moduleResourcesStore.moduleResources;

    let request = new ModuleWithResourcesAndTasksRequestImpl({
      ...this.module,
      moduleResources: moduleResources.map(
        (moduleResource) => new ModuleResourceRequestImpl(moduleResource)
      ),
    });

    let setModuleResourcesIds = (ids: string[]) => {
      moduleResources.forEach(
        (
          moduleResource:
            | ModuleResourceWithScenarioOrMaterialResponseApi
            | ModuleResourceRowDTO,
          index
        ) => {
          moduleResource.moduleResourceId = ids[index];
        }
      );
    };

    if (CheckArgs.CheckNullOrUndefinedOrEmptyString(this.module.moduleId)) {
      savePromise = ModuleServerClient.sendToCreateModuleAsync(request).then(
        (moduleIds: ModuleIdsApi | null) => {
          if (moduleIds !== null) {
            this.setId(moduleIds.moduleId);

            setModuleResourcesIds(moduleIds.moduleResourceIds);
          }

          return moduleIds ? moduleIds.moduleId : null;
        }
      );
    } else {
      savePromise = ModuleServerClient.sendToUpdateModuleAsync(
        this.module.moduleId!,
        request
      ).then((moduleIds: ModuleIdsApi | null) => {
        if (moduleIds !== null) {
          setModuleResourcesIds(moduleIds.moduleResourceIds);
        }

        return null;
      });
    }

    return savePromise;
  }

  setModule = (module: ModuleWithResourcesAndTasksResponseApi) => {
    this.module = new ObservableModulePropImpl(module);
    this.moduleResourcesStore.setModuleResources(module.moduleResources);
  };

  setId = (moduleId: string) => {
    this.module.onChangeId(moduleId);
  };

  loadModuleWithResourcesAndTasksAsync = async (
    moduleId: string
  ): Promise<ModuleWithResourcesAndTasksResponseApi | never> => {
    return ModuleServerClient.sendToGetModuleWithResourcesAndTasksByModuleIdAsync(
      moduleId
    ).then((module) => {
      this.setModule(module);
      return module;
    });
  };

  loadNewModuleAsync =
    async (): Promise<ModuleWithResourcesAndTasksResponseApi> => {
      let module = new EmptyModuleWithResourcesAndTasksImpl();
      this.setModule(module);
      return module;
    };
}
